@if (customerAccountData && (customerAccountData.internetProvider)) {
  <div class="windsteam-customer-account-container flex flex-column gap-3 mb-5 text-center"
    >
    <div class="text-left">
      <span class="title">
        <app-translate key="WINDSTREAM_CUSTOMER_ACCOUNT_SETUP"></app-translate>
      </span>
    </div>
    @if (customerAccountData && customerAccountData.internetProvider) {
      <div class="text-left">
        <span class="sub-title">
          <app-translate key="WINDSTREAM_SUBTITLE"></app-translate>
        </span>
      </div>
    }
    <p-divider></p-divider>
    <div class="windsteam-customer-account-container flex flex-column gap-3 mb-5" [formGroup]="securityInformationForm">
      <div class="flex flex-column gap-3 w-full align-items-center">
        <div class="flex gap-2 align-items-center">
          <span class="text-base font-semibold">Set up a 4 digit account pin</span>
          <i class="pi pi-info-circle align-self-center color-sara-blue" severity="secondary"
            tooltipPosition="top" (onClick)="legendPopover.toggle($event)"
            (mouseenter)="legendPopover.toggle($event)">
            <p-popover #legendPopover styleClass="border-1 border-round-lg w-16rem"
              my="center top" at="right center">
              <div class="flex flex-column font-bold">
                <div class="flex justify-content-center text-primary-700">
                  <span>
                    Why is this necessary?
                  </span>
                </div>
                <p-divider></p-divider>
                <!-- <div>
                <p class="text-sm m-0 p-0 line-height-3">
                  For authentication purposes, customers are required to set up a
                  6 or 8
                  digit passcode and a security question & answer. This
                  information will
                  be used to verify you whenever you call about your account.
                  Please make
                  a note of this information.
                </p>
              </div> -->
            </div>
          </p-popover>
        </i>
      </div>
      <div class="flex gap-3 w-full justify-content-center text-left">
        <div class="flex flex-column w-12 sm:w-5 md:w-4 lg:w-3">
          <label htmlFor="accountPin" class="form-label">
            Account Pin
          </label>
          <input pInputText appMaskInput [maxLength]="8" placeholder="Enter passcode"
            formControlName="accountPin" class="w-full skinny app-text-masked"
            (keypress)="onKeyPressAllowOnlyDigits($event)" />
          @if (shouldShowError('accountPin')) {
            <div class="p-error">
              {{getErrorMessage('accountPin')}}
            </div>
          }
        </div>
        <div class="flex flex-column w-12 sm:w-5 md:w-4 lg:w-3">
          <label htmlFor="confirmAccountPin" class="form-label">
            Confirm Account Pin
          </label>
          <input pInputText appMaskInput [maxLength]="8" placeholder="Enter passcode"
            formControlName="confirmAccountPin" class="w-full skinny app-text-masked"
            (keypress)="onKeyPressAllowOnlyDigits($event)" />
          @if (shouldShowError('confirmAccountPin')) {
            <div class="p-error">
              {{getErrorMessage('confirmAccountPin')}}
            </div>
          }
        </div>
      </div>
    </div>
    <div class="flex flex-column gap-2">
      <span class="text-base font-semibold">Windstream requires SMS verification to continue with
      the order</span>
      <span class="text-sm font-normal">
        To ensure we have captured your service address correctly, please review the address in
        the SMS text and if it is correct, please provide me the verification code.
      </span>
    </div>
    <div class="flex justify-content-center w-full">
      <div class="flex flex-column text-left">
        <label htmlFor="phoneNumber" class="form-label">
          Phone Number
        </label>
        <input type="text" class="w-full skinny" (input)="formatPhone($event, 'phoneNumber')"
          placeholder="Enter a phone #" max="12" maxlength="12" pInputText formControlName="phoneNumber" />
        @if (shouldShowError('phoneNumber')) {
          <div class="p-error">
            {{getErrorMessage('phoneNumber')}}
          </div>
        }
      </div>
    </div>
    <div>
      <p-button label="SEND CODE" [outlined]="true" styleClass="button text-base" (click)="sendCode()"
      [disabled]="false"></p-button>
    </div>
    <div class="flex gap-3 w-full align-items-center">
      <div class="flex gap-3 w-full justify-content-center text-left">
        <div class="flex flex-column w-12 sm:w-5 md:w-4 lg:w-3">
          <label htmlFor="verificationCode" class="form-label">
            Verification Code
          </label>
          <input type="text" placeholder="Enter code" pInputText formControlName="verificationCode"
            class="mb-1 skinny w-full" />
          @if (shouldShowError('verificationCode')) {
            <div class="p-error">
              {{getErrorMessage('verificationCode')}}
            </div>
          }
        </div>
        <div class="flex flex-column w-12 sm:w-5 md:w-4 lg:w-3">
          <label htmlFor="confirmCode" class="form-label">
            Confirm Code
          </label>
          <input type="text" placeholder="Enter code" pInputText formControlName="confirmCode"
            class="mb-1 skinny w-full" />
          @if (shouldShowError('confirmCode')) {
            <div class="p-error">
              {{getErrorMessage('confirmCode')}}
            </div>
          }
        </div>
      </div>
    </div>
    <p-divider class="flex justify-content-center w-full"></p-divider>
    <div class="flex flex-column gap-3 w-full align-items-center">
      <span class="text-base font-semibold">
        Please collect the customer's current Internet provider name
      </span>
      <div class="align-self-center flex flex-column md:w-7 w-full">
        <input type="text" placeholder="Enter name" pInputText formControlName="currentInternetProviderName"
          class="mb-1 skinny w-full" />
        @if (shouldShowError('currentInternetProviderName')) {
          <div class="p-error text-left">
            {{getErrorMessage('currentInternetProviderName')}}
          </div>
        }
      </div>
    </div>
    <p-divider class="flex justify-content-center w-full"></p-divider>
    <div class="flex flex-column gap-3 w-full align-items-center">
      <span class="text-base font-semibold">Do you have a Windstream Referral ID?
      (optional)</span>
      <div class="align-self-center flex flex-column md:w-7 w-full">
        <input type="text" placeholder="Enter code" pInputText formControlName="windstreamReferralId"
          class="mb-1 skinny w-full" />
      </div>
    </div>
    <p-divider class="flex justify-content-center w-full"></p-divider>
    <div class="flex flex-column gap-3 w-full align-items-center">
      <span class="text-base font-semibold">Does the customer have comments to pass to Windstream
      about their order or installation?</span>
      <div class="flex flex-wrap gap-3 w-full justify-content-center text-left">
        <div class="flex flex-column md:w-7 w-full">
          <label htmlFor="accountPin" class="form-label">
            Comments (optional)
          </label>
          <textarea rows="2" cols="23" pTextarea formControlName="comments"></textarea>
        </div>
      </div>
    </div>
    <p-divider class="flex justify-content-center w-full"></p-divider>
    <div class="flex flex-column gap-3 w-full align-items-center">
      <span class="text-base font-semibold">Customer can add an additional authorized user
      below.</span>
      <div class="flex flex-wrap gap-3 w-full justify-content-center text-left">
        <div class="flex flex-column md:w-7 w-full">
          <label htmlFor="authorizedUserFullName" class="form-label">
            Full Name
          </label>
          <input type="text" placeholder="Enter name" pInputText formControlName="authorizedUserFullName"
            class="mb-1 skinny w-full" />
          @if (shouldShowError('authorizedUserFullName')) {
            <div class="p-error">
              {{getErrorMessage('authorizedUserFullName')}}
            </div>
          }
        </div>
        <div class="flex flex-column  md:w-3 w-full">
          <label htmlFor="authorizedUserPhoneNumber" class="form-label">
            Phone Number
          </label>
          <input type="text" class="w-full skinny" (input)="formatPhone($event, 'authorizedUserPhoneNumber')"
            placeholder="Enter a phone #" max="12" maxlength="12" pInputText
            formControlName="authorizedUserPhoneNumber" />
          @if (shouldShowError('authorizedUserPhoneNumber')) {
            <div class="p-error">
              {{getErrorMessage('authorizedUserPhoneNumber')}}
            </div>
          }
        </div>
      </div>
    </div>
    <div class="mt-3">
      <div class="mb-3">
        <p-button [label]="languageService.getTranslation('SUBMIT')" (onClick)="onSubmitClicked()"
          styleClass="p-button-lg w-full p-button-primary" />
      </div>
      <div class="mb-3">
        <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
          (onClick)="onCancelClick()" />
      </div>
    </div>
    <div>
      <span class="sub-title">
        <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
      </span>
    </div>
  </div>
</div>
}

@if (!customerAccountData || (!customerAccountData.internetProvider)) {
  <div>
    <app-translate key="SECURITY_FLAGS_FALSE"></app-translate>
  </div>
}

<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancel($event)"></app-confirm-popup>